<div class="feature" *ngIf="(showV2Template$ | async) === true && featureInfoV2$ | async as info">
  <app-restricted-content [featureInfo]="info"></app-restricted-content>
</div>

<div
  class="feature"
  *ngIf="(showV2Template$ | async) === false && featureInfo$ | async as info"
  [style.background-image]="backgroundImageUrlSanitized"
>
  <app-access-restricted-content
    [featureInfo]="info"
    userEventCategory="restricted-page-action"
  ></app-access-restricted-content>
</div>
